import React from 'react';
import {
    TextField,
    Button,
    Paper,
    Typography,
    Stack,
    Box,
} from '@mui/material';
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {useNotification} from "../../utils/hooks/useNotification";
import {postFetcher} from "../../utils/api/fetchers";
import {useNavigate} from "react-router-dom";
import {ClubCreateSchema, clubCreateSchema} from "../../schemas/club/clubCreateSchema";
import {Club} from "../../schemas/club/clubSchema";

const ClubCreate: React.FC = () => {
    const navigate = useNavigate();
    const {showNotification} = useNotification();
    const {register, handleSubmit, formState: {errors}} = useForm<ClubCreateSchema>({
        resolver: zodResolver(clubCreateSchema),
    });

    const onSubmit = async (data: ClubCreateSchema) => {
        postFetcher<ClubCreateSchema, Club>("/clubs", data)
            .then(() => {
                showNotification("Klub byl úspěšně vytvořen", "success");
                navigate('/clubs');
            })
            .catch((error) => {
                if (error.response?.status === 409) {
                    showNotification("Klub s tímto jménem již existuje", "error");
                } else {
                    showNotification("Nepodařilo se vytvořit klub", "error");
                }
            });
    };

    return (
        <Paper elevation={3} sx={{padding: 4, maxWidth: 600, margin: '0 auto'}}>
            <Typography variant="h4" gutterBottom>
                Vytvoření klubu
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={3}>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Jméno"
                        variant="standard"
                        required
                        {...register('name')}
                        error={!!errors.name}
                        helperText={errors.name?.message}
                    />
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        Vytvořit klub
                    </Button>
                </Stack>
            </Box>
        </Paper>
    );
};

export default ClubCreate;